export default __webpack_public_path__ + "media/images/backgrounds/bg-14-1920x760-0aebd0231750c9325a46ce7b54a82117.jpg";